import { useQuery } from '@tanstack/react-query';
import { employeeImportService } from '../services/employeeImportService';

export const importHistoryQueryKey = ['employee-import-history'] as const;

export const useImportHistory = () =>
    useQuery({
        queryKey: importHistoryQueryKey,
        queryFn: () => employeeImportService.getHistory(),
    });
